import styles from "./styles.module.scss";
import ModalLayout from "components/modal/modal-layout/ModalLayout";
import { Button } from "react-bootstrap";
import messages from "messages";
import { usePhonePortraitContext } from "contexts/phone-portrait-context";
import type { ComponentPropsWithoutRef, ReactNode } from "react";
import Checkbox from "components/checkbox/Checkbox";
import getClasses from "utils/getClasses";

type Props = {
  labelTitle?: string;
  children: ReactNode;
  labelCancel?: string;
  labelConfirm?: string;
  show: boolean;
  hideCancel?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  onCheckbox?: (e: any) => void;
  checkboxText?: string;
  footerClass?: string;
  disableConfirm?: boolean;
  disableCancel?: boolean;
} & Omit<
  ComponentPropsWithoutRef<typeof ModalLayout>,
  "onHide" | "show" | "children"
>;

const ConfirmModal = ({
  labelTitle,
  children,
  labelCancel,
  labelConfirm,
  show,
  hideCancel,
  onConfirm,
  onCancel,
  onCheckbox,
  checkboxText,
  footerClass,
  disableConfirm = false,
  disableCancel = false,
  ...props
}: Props) => {
  const { isPhonePortrait } = usePhonePortraitContext();
  return (
    <ModalLayout
      size={"lg"}
      show={show}
      onHide={onCancel}
      // raise z-index since there are occasions that need to show overlay
      backdropClassName={styles["confirm-modal__backdrop"]}
      contentClassName={getClasses(
        !isPhonePortrait
          ? styles["confirm-modal__content"]
          : styles["confirm-modal__content--phone"],
        props.contentClassName,
      )}
      headerClass={styles["confirm-modal__header"]}
      bodyClass={styles["confirm-modal__body"]}
      footerClass={getClasses(footerClass, styles["confirm-modal__footer"])}
      {...props}
      Header={
        <span className={styles["confirm-modal__title"]}>
          {labelTitle || messages.areYouSure}
        </span>
      }
      footerJustification={onCheckbox && checkboxText && "space-between"}
      Footer={
        <>
          {onCheckbox && checkboxText && (
            <div className={styles["confirm-modal__checkbox-wrapper"]}>
              <Checkbox
                variant={"rectangle"}
                labelClassName={checkboxText}
                label={checkboxText}
                onChange={onCheckbox}
              />
            </div>
          )}
          {!hideCancel && (
            <Button
              className={styles["confirm-modal__cancel"]}
              onClick={onCancel}
              variant={"outline-primary"}
              disabled={disableCancel}
            >
              {labelCancel || messages.cancel}
            </Button>
          )}

          <Button
            className={styles["confirm-modal__apply"]}
            onClick={onConfirm}
            disabled={disableConfirm}
          >
            {labelConfirm || messages.delete}
          </Button>
        </>
      }
    >
      {children}
    </ModalLayout>
  );
};
export default ConfirmModal;
